import React from 'react'
import { AccountDetails } from '@Types'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'

interface Props {
  account: AccountDetails
}

export const AccountLookupDetails = ({ account }: Props) => {
  const { accountNumber, accountTitle, restrictionCode } = account

  return (
    <Box data-testid='accountLookupDetails'>
      <Text color={'gray.500'} as='h4'>
        Transfer to:
      </Text>
      <Box borderLeftWidth={1} borderLeftColor={'gray.300'} pl={4}>
        <Stack>
          {accountTitle && (
            <Flex data-test-handle='row-title'>
              <Text fontWeight={'semibold'} width={'9em'}>
                Title
              </Text>
              <Text data-test-handle='account-title'>{accountTitle}</Text>
            </Flex>
          )}
          <Flex data-test-handle='row-account-number'>
            <Text fontWeight={'semibold'} width={'9em'}>
              Account #
            </Text>
            <Text data-test-handle='account-number'>{accountNumber}</Text>
          </Flex>
          {restrictionCode && (
            <Flex data-test-handle='row-restriction-code'>
              <Text fontWeight={'semibold'} width={'9em'}>
                Account Rest.
              </Text>
              <Text data-test-handle='restriction-code' color='red.500'>
                {restrictionCode}
              </Text>
            </Flex>
          )}
        </Stack>
      </Box>
    </Box>
  )
}
